import { Info } from '@mui/icons-material';
import { Grid, Typography } from '@mui/material';
import TextField from '@mui/material/TextField';
import { LightTooltip } from 'lib/designSystem/WhiteTooltip';
import { formatMoney } from 'lib/functions/utils';
import ClientInfo from 'pages/Finance/Components/Financing/Factoring/components/Simulator/components/ClientInfo';
import DocumentsForm from 'pages/Finance/Components/Financing/Factoring/components/Simulator/components/DocumentsForm';
import { SimulatorDocument } from 'pages/Finance/Components/Financing/Factoring/components/Simulator/types';
// import DocumentsSuggestedContainer from 'pages/Finance/Components/Financing/common/documentSugestion';
import React from 'react';

interface SimulatorFormData {
  totalAmount: number;
  advance: number | string;
  rate: number | string;
  fundRate: number;
  arrearRate: number | string;
  arrearType: 'rate' | 'table';
  guaranteeAmount: number;
  guaranteeObservation: string;
  operationCostComissionFixed: number;
  operationCostComissionVariable: number;
  operationCostComissionVariablePercentage: number | string;
  expensesCost: number;
  requestDate: string;
  paymentDate: string;
  amountToApply: number;
  selectedDocumentsToApply: string[];
  arrearTableId?: string;
}

interface SimulatorParametersProps {
  formData: SimulatorFormData;
  handleChange: (id: string, value: string) => void;
  selectedRequest: {
    businessName: string;
    businessIdentifier: string;
    requestDate: string;
    [key: string]: unknown;
  };
  documents: SimulatorDocument[];
  setDocuments: (documents: SimulatorDocument[]) => void;
  selected: string[];
  setSelected: (selected: string[]) => void;
  setDocumentsToApply: (documents: SimulatorDocument[]) => void;
  documentsToApply: SimulatorDocument[];
  maxAmount: number;
  simulatorDocuments: Array<{
    id: string;
    amount: number;
    paymentDate: string;
    debtorRut: string;
    active: boolean;
  }>;
  setSimulatorDocuments: React.Dispatch<
    React.SetStateAction<
      Array<{
        id: string;
        amount: number;
        paymentDate: string;
        debtorRut: string;
        active: boolean;
      }>
    >
  >;
  business?: {
    businessName?: string;
    identifier: string;
  };
}

const CustomTooltip = (text: Array<Array<string>>) => (
  <div style={{ padding: 10 }}>
    <div style={{ display: 'flex', alignItems: 'center', paddingBottom: 10 }}>
      <Typography variant="body1">Descripción</Typography>
    </div>
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {text.map((row, index) => (
        <div key={index} style={{ marginBottom: 5 }}>
          <strong>{row[0]}:</strong> {row[1]}
        </div>
      ))}
    </div>
  </div>
);

const SimulatorParameters: React.FC<SimulatorParametersProps> = ({
  formData,
  handleChange,
  selectedRequest,
  simulatorDocuments,
  setSimulatorDocuments,
  business,
  // documents,
  // setDocuments,
  // selected,
  // setSelected,
  // setDocumentsToApply,
  // documentsToApply,
  // maxAmount,
}) => {
  const gridStyle = {
    alignContent: 'center',
    alignItems: 'center',
    padding: '4px',
    paddingRight: 23,
  };

  // const handleAmountToApply = (value: string) => {
  //   const newValue = Number(value.replace('$', '').replaceAll('.', ''));
  //   handleChange('amountToApply', String(newValue));
  // };

  // const handleSelectDocument = (ids: string[]) => {
  //   setSelected(ids);
  // };

  return (
    <div
      style={{
        padding: '0px 0px',
        borderRight: '1px solid rgba(0, 0, 0, 0.12)',
      }}
    >
      {/* Fila 0: Información del Cliente */}
      {business && (
        <div style={{ marginBottom: '16px' }}>
          <ClientInfo business={business} />
        </div>
      )}

      {/* Fila 1: Documentos */}
      <Grid container style={gridStyle} columnSpacing={3} rowSpacing={1}>
        <Grid item xs={12}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography fontWeight={600}>Documentos a Simular</Typography>
            <LightTooltip
              title={CustomTooltip([
                [
                  'Documentos',
                  'Agrega los documentos con sus montos y fechas de vencimiento.',
                ],
              ])}
            >
              <Info style={{ marginLeft: 6, fontSize: 14 }} />
            </LightTooltip>
          </div>
          <DocumentsForm
            documents={simulatorDocuments}
            setDocuments={setSimulatorDocuments}
            operationDate={selectedRequest?.requestDate || formData.requestDate}
          />
        </Grid>
      </Grid>

      <Grid container style={gridStyle} columnSpacing={3} rowSpacing={1}>
        <Grid item xs={6}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography fontWeight={600}>Montos</Typography>
            <LightTooltip
              title={CustomTooltip([
                [
                  'Anticipo',
                  'Porcentaje a financiar respecto al total del valor de la operación.',
                ],
              ])}
            >
              <Info style={{ marginLeft: 6, fontSize: 14 }} />
            </LightTooltip>
          </div>
          <Typography variant="body1">Anticipo (%)</Typography>
          <TextField
            value={formData.advance}
            placeholder="100"
            type="number"
            fullWidth
            style={{ padding: '0px !important' }}
            onChange={(e) => handleChange('advance', e.target.value)}
          />
        </Grid>
        <Grid item xs={6}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography fontWeight={600}>Tasas</Typography>
            <LightTooltip
              title={CustomTooltip([
                [
                  'Interés',
                  'Interés aplicado a la operación. Se descuenta del monto a financiar como diferencia de precio.',
                ],
              ])}
            >
              <Info style={{ marginLeft: 6, fontSize: 14 }} />
            </LightTooltip>
          </div>
          <Grid container columnSpacing={3}>
            <Grid item xs={12}>
              <Typography variant="body1">Interés (%)</Typography>
              <TextField
                value={formData.rate}
                type="number"
                fullWidth
                placeholder="2.2"
                onChange={(e) => handleChange('rate', e.target.value)}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* <Grid container style={gridStyle} columnSpacing={3} rowSpacing={1}>
        <Grid item xs={12}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography fontWeight={600}>Descuentos</Typography>
            <LightTooltip
              title={CustomTooltip([
                [
                  'Monto en garantía',
                  'Monto reservado o en garantía que será liberado cuando el cliente cumpla con los requisitos de la operación.',
                ],
                [
                  'Documentos a aplicar',
                  'Documentos aplicados a la operación abonar al pago de otras facturas.',
                ],
              ])}
            >
              <Info style={{ marginLeft: 6, fontSize: 14 }} />
            </LightTooltip>
          </div>
        </Grid>
      </Grid>

      <Grid container style={gridStyle} columnSpacing={3} rowSpacing={1}>
        <Grid item xs={6}>
          <Typography variant="body1">Monto en garantía</Typography>
          <TextField
            value={formatMoney(formData.guaranteeAmount)}
            type="text"
            fullWidth
            onChange={(e) => handleChange('guaranteeAmount', e.target.value)}
          />
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">Documentos a aplicar ($)</Typography>
          <DocumentsSuggestedContainer
            businessIdentifier={selectedRequest.businessIdentifier}
            setAmountToApply={handleAmountToApply}
            amountToApply={formData.amountToApply}
            maxAmount={maxAmount}
            selected={selected}
            setSelected={handleSelectDocument}
            documents={documents}
            setDocuments={setDocuments}
            setDocumentsToApply={setDocumentsToApply}
            addIconPlacement="end"
            disabled={false}
            documentsToApply={documentsToApply}
            operationDate={selectedRequest.requestDate}
          />
        </Grid>
      </Grid> */}

      {/* Fila 4: Comisión operación y Otros gastos */}
      <Grid container style={gridStyle} columnSpacing={3} rowSpacing={1}>
        <Grid item xs={6}>
          <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
            <Typography variant="body1" fontWeight={600}>
              Comisión operación
            </Typography>
            <LightTooltip
              title={CustomTooltip([
                [
                  'Fijo',
                  'Monto fijo a cobrar por la operación. Reducirá el monto a financiar',
                ],
                [
                  'Variable',
                  'Porcentaje a cobrar por la operación. Reducirá el monto a financiar',
                ],
              ])}
            >
              <Info style={{ marginLeft: 6, fontSize: 14 }} />
            </LightTooltip>
          </div>
          <Grid container columnSpacing={3}>
            <Grid item xs={6}>
              <Typography variant="body1">Fijo ($)</Typography>
              <TextField
                value={formatMoney(formData.operationCostComissionFixed)}
                type="text"
                fullWidth
                onChange={(e) =>
                  handleChange('operationCostComissionFixed', e.target.value)
                }
              />
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1">Variable (%)</Typography>
              <TextField
                value={formData.operationCostComissionVariablePercentage}
                type="number"
                fullWidth
                onChange={(e) =>
                  handleChange('operationCostComissionVariable', e.target.value)
                }
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
            <Typography fontWeight={600}>Otros gastos</Typography>
            <LightTooltip
              title={CustomTooltip([
                [
                  'Fijo',
                  'Valor de cualquier otro gasto en el que se incurra en la operación',
                ],
              ])}
            >
              <Info style={{ marginLeft: 6, fontSize: 14 }} />
            </LightTooltip>
          </div>
          <Typography variant="body1">Fijo ($)</Typography>
          <TextField
            value={formatMoney(formData.expensesCost)}
            type="text"
            fullWidth
            onChange={(e) => handleChange('expensesCost', e.target.value)}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default SimulatorParameters;
